<template>
    <div class="job-detail">
      <div class="position-base-info">
        <div class="position-info">
          <div class="position-base-info-row"><span class="position-state">招聘中</span></div>
          <div class="position-base-info-row">
            <span class="position-name">{{positionDetailInfo['positionName'] ? positionDetailInfo['positionName'] : '--'}}</span>
            <span class="position-salary">{{positionDetailInfo['salaryDict'] ? positionDetailInfo['salaryDict']['dictName'] : '--'}}</span>
          </div>
          <div class="position-base-info-row">
            <span class="position-city">{{positionDetailInfo['positionCity'] ? positionDetailInfo['positionCity'] : '--'}}</span>
            <span class="divide-point">·</span>
            <span class="position-work-experience">{{positionDetailInfo['experienceDict'] ? positionDetailInfo['experienceDict']['dictName'] : '--'}}</span>
            <span class="divide-point">·</span>
            <span class="position-education">{{positionDetailInfo['academicDegreeDict'] ? positionDetailInfo['academicDegreeDict']['dictName'] : '--'}}</span>
          </div>
          <div class="position-base-info-row">
            <span v-for="(item, index) of companyWelfareArr" :key="index">
              <span  class="company-welfare-item" v-if="index <= 5">{{item}}</span>
            </span>
            <el-tooltip placement="bottom-end">
              <div slot="content" style="padding: 15px;max-width: 500px">
                <span v-for="(item, index) of companyWelfareArr" :key="index">
                  <span  class="company-welfare-item tooltip-item">{{item}}</span>
                </span>
              </div>
              <span  class="company-welfare-item more-item" v-if="companyWelfareArr.length > 5">···</span>
            </el-tooltip>

          </div>
        </div>
        <div class="connection-op" v-if="$store.get('user').roleName !== 'enterprise'">
          <!--<div class="connect-right-now">
            立即沟通
          </div>-->
          <div class="connect-update-resume" @click="addToCollection()"><i class="el-icon-star-off"></i><span>添加收藏</span></div>
          <div class="connect-update-resume" @click="goResumePage()"><i class="el-icon-document"></i><span>更新简历</span></div>
          <div class="connect-update-resume" @click="sendResume()"><i class="el-icon-s-promotion"></i><span>投递简历</span></div>
          <div class="connect-update-resume" @click="$alert('功能待开发。。。')"><i class="el-icon-chat-dot-square"></i><span>在线沟通</span></div>
        </div>
      </div>
      <div class="position-des">
        <div class="position-des-title">职位描述：</div>
        <div class="position-des-content">{{positionDetailInfo.description ? positionDetailInfo.description : '--'}}</div>
      </div>
      <div class="position-skill-req">
        <div class="position-skill-req-title">技能要求：</div>
        <div class="position-skill-req-content">{{positionDetailInfo.skillRequirement ? positionDetailInfo.skillRequirement : '--'}}</div>
      </div>
      <br><br><br>
      <div class="publish-owner-info">
        职位发布者信息
      </div>

      <div class="company-info">
        公司信息
      </div>
    </div>
</template>

<script>
export default {
  name: 'JobDetail',
  data () {
    return {
      positionId: null,
      positionDetailInfo: {},
      companyWelfareArr: ['五险一金', '定期体检', '年终奖', '带薪年假', '员工旅游', '免费班车', '餐补', '零食下午茶', '节日福利', '交通补助']
    }
  },
  methods: {
    goResumePage () {
      let routeData = this.$router.resolve({
        path: `/resume`
      })
      window.open(routeData.href, '_blank')
    },
    addToCollection () {
      this.$http.post(this.$api.createOrUpdateRelation.url, {
        positionId: this.positionId,
        follow: 2
      }).then(_ => {
        if (_ && _.code === 200) {
          this.$message.success('收藏成功！')
        }
      }).catch(e => {
        console.log(e)
      })
    },
    sendResume () {
      // 投递简历
      this.$confirm('投递简历后，企业将获取到您的个人信息，是否继续?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'info'
      }).then(() => {
        this.$http.post(this.$api.createOrUpdateRelation.url, {
          positionId: this.positionId,
          apply: 2
        }).then(_ => {
          if (_ && _.code === 200) {
            this.$message.success('简历已投递！')
          }
        }).catch(e => {
          console.log(e)
        })
      })
    }
  },
  created () {
    this.positionId = this.$route.query.positionId
    this.$http.post(this.$api.savePositionViewRecord.url, {
      positionId: this.positionId
    }).then(_ => {
      console.log('该职位浏览记录+1', _)
    })
    this.$http.get(this.$api.getByPositionId.url, {
      id: this.positionId
    }).then(_ => {
      if (_ && _.code === 200 && _.data) {
        this.positionDetailInfo = _.data

        // let userCode = _.data.userCode
        // let companyCode = _.data.companyCode
      }
    })
  }
}
</script>

<style scoped>
  .job-detail {
    width: 1200px;
    margin: auto;
    height: 100vh;
    background: #ffffff;
    text-align: left;
  }
  .position-base-info {
    height: 170px;
    width: 100%;
    padding: 20px;
    /*background: #a0cfff;*/
    position: relative;
    white-space: nowrap;
  }
  .position-info {
    display: inline-block;
    width: 70%;
    height: 100%;
    overflow: hidden;
  }
  .connection-op {
    display: inline-block;
    width: calc(30% - 40px);
    height: 100%;
    overflow: hidden;
  }
  .position-base-info-row {
    margin-bottom: 20px;
  }
  .position-name {
    font-size: 26px;
    color: #409EFF;
  }
  .divide-point, .position-city, .position-work-experience, .position-education {
    color: #666666;
  }
  .divide-point {
    font-size: 18px;
  }
  .position-state, .position-salary {
    color: #FA6A43;
  }
  .position-salary {
    font-size: 22px;
    margin-left: 10px;
  }
  .company-welfare-item {
    color: #409EFF;
    border: 1px solid #409eff;
    margin-right: 15px;
    padding: 2px 10px;
    border-radius: 20px;
    line-height: 30px;
  }
  .tooltip-item {
    border-color: #ffffff;
    color: #ffffff;
  }
  .more-item {
    cursor: pointer;
  }
  .more-item:hover {
    background: #D9ECFF;
  }
  .connect-update-resume {
    color: #FA6A43;
    font-size: 20px;
    cursor: pointer;
    margin-bottom: 20px;
  }
  .el-icon-star-off, .el-icon-document, .el-icon-s-promotion, .el-icon-chat-dot-square {
    margin-right: 8px;
  }
  .position-des-title, .position-skill-req-title {
    padding: 0 26px;
    position: relative;
    font-size: 16px;
  }

  .position-des-title::before, .position-skill-req-title::before {
    position: absolute;
    content: '';
    height: 14px;
    width: 3px;
    background: #409EFF;
    left: 20px;
    top: 4px;
  }
  .position-des-content, .position-skill-req-content {
    padding: 10px 26px;
    color: #666666;
  }
</style>



// WEBPACK FOOTER //
// src/components/JobDetailPage/JobDetail.vue